// extracted by mini-css-extract-plugin
export default {"root":"CompensationDetailsModal_root__SOMyA","placeHolderShimmer":"CompensationDetailsModal_placeHolderShimmer__mFXc-"};